<template>
  <div>
    <v-card class="table-card mt-4">
      <v-card-title>
        <span class="accent--text">Протоколы</span>
        <v-spacer></v-spacer>

        <v-text-field
          v-model="tableSearch"
          class="mt-0 pt-0 table-search"
          append-icon="mdi-magnify"
          label="Поиск"
          single-line
          hide-details
          clearable
        />
      </v-card-title>

      <v-data-table
        ref="protocolsTable"
        class="base-table elevation-0"
        fixed-header
        hide-default-footer
        :headers="headers"
        :items="protocolsLocal.list"
        :search="tableSearch"
        :items-per-page="-1"
      >
        <template #item.fullName="{ item }">
          <span>{{ item.fullName || '-' }}</span>
        </template>

        <template #item.date="{ item }">
          <span>{{ item.date || '-' }}</span>
        </template>

        <template #item.number="{ item }">
          <span>{{ item.number || '-' }}</span>
        </template>

        <template slot="no-data">
          <div class="py-3">Нет слушателей на данном цикле</div>
        </template>

        <template slot="no-results">
          <div class="py-3">Ничего не найдено</div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Protocols } from '@/models'

export default {
  name: 'ProtocolTable',

  props: {
    infoBlockHeight: Number,
    protocols: Array
  },

  mounted() {
    this.setTableHeight()
    window.addEventListener("resize", this.setTableHeight)
  },

  destroyed() {
    window.removeEventListener("resize", this.setTableHeight)
  },

  data: () => ({
    dataLoaded: false,
    tableSearch: null,
    headers: [
      { text: 'ФИО', value: 'fullName', sortable: false, align: 'left' },
      { text: 'Дата протокола итоговой аттестации', value: 'date', sortable: false, align: 'center' },
      { text: 'Номер протокола итоговой аттестации', value: 'number', sortable: false, align: 'center' }
    ],

    protocolsLocal: new Protocols()
  }),

  computed: {
    ...mapGetters('system', ['techMessageHeight']),
    ...mapGetters('cycle', ['cycleId', 'isCycleComplete'])
  },

  methods: {
    setTableHeight() {
      this.$nextTick(() => {
        if (this.$refs?.protocolsTable) {
          const otherElements = 365 + this.infoBlockHeight + this.techMessageHeight
          this.$refs.protocolsTable.$el.style.maxHeight = window.innerHeight - otherElements + 'px'
        }
      })
    }
  },

  watch: {
    infoBlockHeight() {
      this.setTableHeight()
    },

    protocols(list) {
      list.length && this.protocolsLocal.buildFromAPI(list)
    }
  }
}
</script>